import Cookies from 'js-cookie';

// At the moment the frontend has no way to know if there is an intercom or not
// that's why we are using a cookie to show/hide QR code visit features
export const areQrCodeVisitsEnabled = (): boolean => Cookies.get('INTERCOM') === 'TRUE';
